import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeTrailingS',
})
export class RemoveTrailingSPipe implements PipeTransform {
  public transform(value: string): unknown {
    return value.endsWith('s') ? value.slice(0, -1) : value;
  }
}
